"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.get_csrf_token_header = exports.get_csrf_token = void 0;
var csrf_token = null;
function get_csrf_token() {
    if (csrf_token !== null)
        return csrf_token;
    var csrf_meta_element = document.querySelector('meta[name="csrf-token"]');
    if (!(csrf_meta_element instanceof HTMLMetaElement))
        throw new Error("Could not find csrf token.");
    csrf_token = csrf_meta_element.getAttribute('content');
    if (!(csrf_token))
        throw new Error("Could not find csrf token.");
    return csrf_token;
}
exports.get_csrf_token = get_csrf_token;
function get_csrf_token_header() {
    return {
        'X-CSRF-Token': get_csrf_token()
    };
}
exports.get_csrf_token_header = get_csrf_token_header;
